import { render, staticRenderFns } from "./overview-cell-action.vue?vue&type=template&id=67ee188b&scoped=true"
import script from "./overview-cell-action.vue?vue&type=script&lang=ts"
export * from "./overview-cell-action.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ee188b",
  null
  
)

export default component.exports